const PAPER_TYPES = [
  { id: "offset_75", label: "Offset 75 g", grammage: 75, thicknessMicron: 100 },
  { id: "offset_90", label: "Offset 90 g", grammage: 90, thicknessMicron: 120 },
  { id: "couche_fosco_90", label: "Couché fosco 90 g", grammage: 90, thicknessMicron: 85 },
  { id: "couche_fosco_115", label: "Couché fosco 115 g", grammage: 115, thicknessMicron: 100 },
  { id: "couche_brilho_150", label: "Couché brilho 150 g", grammage: 150, thicknessMicron: 130 },
  { id: "polen_70", label: "Pólen 70 g", grammage: 70, thicknessMicron: 110 },
  { id: "polen_80", label: "Pólen 80 g", grammage: 80, thicknessMicron: 122 },
];
module.exports = { PAPER_TYPES };
